/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { dataManagerEntryPoint } from '@jira/servicedesk__insight-global-configuration-data-manager/src/dataManagerEntryPoint.entrypoint.tsx';
import { appUsageEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/appUsageEntryPoint.entrypoint.tsx';
import { announcementBannerEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/announcementBannerEntryPoint.entrypoint.tsx';
import { themeSettingsEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/themeSettingsEntryPoint.entrypoint.tsx';
import { iconsPageEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/iconsPageEntryPoint.entrypoint.tsx';
import { statusesPageEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/statusesPageEntryPoint.entrypoint.tsx';
import { commonDataModelEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/commonDataModelEntryPoint.entrypoint.tsx';
import { referenceTypesPageEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/referenceTypesPageEntryPoint.entrypoint.tsx';
import { rolesAndPermissionsEntryPoint } from '@jira/servicedesk__insight-global-configuration-page/src/rolesAndPermissionsEntryPoint.entrypoint.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForInteraction } from '@atlassian/react-async';

type AssetsGlobalSettingsEntryPointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const assetsGlobalSettingsEntryPoint: EntryPoint<
	AssetsGlobalSettingsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsGlobalSettingsEntryPointComponent>(
		/* webpackChunkName: "async-assets-global-settings-entrypoint" */ './index.tsx',
	),
	getPreloadProps: ({ context: { query } }: EntryPointRouteParams) => {
		if (!fg('aurum_assets_new_settings_page')) {
			return {};
		}

		const { menu } = query;
		const defaultMenu = fg('aurum-677-assets-usage-migration')
			? 'app-usage'
			: 'global-reference-types';
		const targetMenu = menu ?? defaultMenu;

		if (targetMenu === 'data-manager') {
			return {
				entryPoints: {
					dataManagerEntryPoint: {
						entryPoint: dataManagerEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'app-usage') {
			return {
				entryPoints: {
					appUsageEntryPoint: {
						entryPoint: appUsageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-permissions') {
			return {
				entryPoints: {
					rolesAndPermissionsEntryPoint: {
						entryPoint: rolesAndPermissionsEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'announcement-banner') {
			return {
				entryPoints: {
					announcementBannerEntryPoint: {
						entryPoint: announcementBannerEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'theme') {
			return {
				entryPoints: {
					themeSettingsEntryPoint: {
						entryPoint: themeSettingsEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-icons') {
			return {
				entryPoints: {
					iconsPageEntryPoint: {
						entryPoint: iconsPageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-statuses') {
			return {
				entryPoints: {
					statusesPageEntryPoint: {
						entryPoint: statusesPageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'commonDataModel') {
			if (!fg('assets_common_data_model_settings')) {
				return {};
			}
			return {
				entryPoints: {
					commonDataModelEntryPoint: {
						entryPoint: commonDataModelEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-reference-types') {
			return {
				entryPoints: {
					referenceTypesPageEntryPoint: {
						entryPoint: referenceTypesPageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}
		return {};
	},
});
